import { MapData } from "@/shared/types/types";
import { darken, desaturate, getLuminance, lighten, parseToRgba, toHex, toRgba } from "color2k";


const cache = {}

export function getTextColor(color: string) {

	if (cache[color])
		return cache[color]

	if (!color)
		return color

	try {

		const luma = getLuminance(color)
		if (luma > 0.5)
			color = desaturate(darken(color, luma - 0.4), .5)

		const ret = toHex(color)
		cache[color] = ret;
		return ret;
	} catch (e) {
		return color;
	}
}

export function safeParseToRgba(color: string) {
	if (!color) return []
	try {
		return parseToRgba(color);
	} catch (e) {
		return [];
	}
}

export function safeDarken(color: string, amount: number) {
	if (!color) return color
	try {
		return darken(color, amount);
	} catch (e) {
		return color;
	}
}

export function safeLighten(color: string, amount: number) {
	if (!color) return color
	try {
		return lighten(color, amount);
	} catch (e) {
		return color;
	}
}

/**
 * Parse a css color and return a hex color without alpha.
 * @param color css color string
 */
export function plainColor(color: string): string {
	if (!color)
		return "#000";

	const c = safeParseToRgba(color);
	if (c.length == 0) {
		return "#000";
	}
	const [red, green, blue] = c;
	return "#" + ((blue | green << 8 | red << 16) | 1 << 24).toString(16).slice(1)
}

export function getAllUsedColors(map: MapData) {
	const colors = new Set<string>();
	const add = (color: string) => colors.add(plainColor(color));

	for (const route of map.routes) {
		add(route.properties.color);
		add(route.properties.heightColor)
		add(route.properties.inactiveColor)
		if (route.properties.legs) {
			for (const leg of route.properties.legs) {
				if (leg.color)
					add(leg.color);
			}
		}
	}

	for (const marker of map.markers) {
		if (marker.color)
			add(marker.color);
	}

	for (const shape of map.shapeLayer.shapes) {
		if ("shapes" in shape) {
			for (const subShape of shape.shapes) {
				add(subShape.properties.color);
				add(subShape.properties.outlineColor);
			}
		} else {
			add(shape.properties.color);
			add(shape.properties.outlineColor);
		}
	}
	return Array.from(colors).map(plainColor);
}